module.exports = __webpack_public_path__ + "assets/logo-foxgid-mobile.b41950f1.svg";